import React from 'react';
import { ProgressBar } from 'react-toolbox/lib/progress_bar';

import theme from './PtProgress.module.css';

export default ({ ...props }) => <ProgressBar {...props} theme={theme} />;
